import { Injectable } from '@angular/core';
import { IssueTypeInterfaceStore } from './issueTypeInterface.store';
import { IssueTypeInterfaceQuery } from './issueTypeInterface.query';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIssueTypeInterface } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
export class IssueTypeInterfaceService extends CrudService<IIssueTypeInterface, IssueTypeInterfaceStore, IssueTypeInterfaceQuery> {
  constructor(
    protected store: IssueTypeInterfaceStore,
    public query: IssueTypeInterfaceQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.ISSUE_TYPE_INTERFACES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }
}
